import axios from "axios";
import React, { useEffect, useState } from "react";
import { baseURL } from "../../constants/Api";
import Skeleton from "../../components/skeletons/skeleton";
import OrderCard from "../../components/order-history/OrderCard";
import BackButton from "../bars/BackButton";
import { onMessage } from "firebase/messaging";
import { messaging } from "../login/firebase/Firebase";
import { HistoryPageView } from "../../utils/Analytics";

function OrderHistoryPage() {
  const [historyArray, setHistoryArray] = useState([]);
  const reservationId = localStorage.getItem("reservationId");
  const appUserId = localStorage.getItem("appUserId");
  const [loading, setLoading] = useState(false);
  const fetchHistory = async (update) => {
    setLoading(update ? false : true) ;
    try {
      await axios({
        url: `${baseURL}/api/allServiceHistory`,
        method: "post",
        data: {
          reservationId: reservationId,
          appUserId,
        },
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        console.log("histort2=====================",response.data);
        if (response.data.success) {
          setLoading(false);
          setHistoryArray(response.data.data);
        }
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

    useEffect(() => {
      fetchHistory();
      onMessage(messaging,(payload)=>{
        console.log(payload);
        // const { title, body, icon } = payload.notification;
        // new Notification(title, {
        //     body,
        //     icon:"https://edayaapp.com/images/blue-1.png",
        //   });
        fetchHistory(true);
      })
      console.log("object")
     }, []);

  const handleDataUpdate = (updatedData) => {
    let newStatus = 'Cancelled';
    const datafromHIs = historyArray;
  
    const updatedDatas = datafromHIs.map((item) =>
      item.id === updatedData ? { ...item, status: newStatus } : item
    );
  
    setHistoryArray(updatedDatas);
     
  };

  useEffect(() => {
    HistoryPageView();
    fetchHistory();
  }, []);

  return (
    <div> 
      {!loading ? (
        <div className="section-wrap mx-4 py-0" style={{padding:"12px", paddingTop:"6px"}}>
          <div className="doc-modal flex-col items-center justify-center mt-2">
            <div className="flex justify-center items-center"></div>
            <div className="head flex items-center gap-4 mb-4">
                <BackButton link="../home"/>
                History / Status</div>
          </div>
         
          {historyArray?.length !== 0 ? (
            <div className="flex flex-col gap-4">
           { historyArray.map((item, i) => (
                 <OrderCard key={i} historyData={item} onDataUpdate={(id)=>handleDataUpdate(id)}/> 
            ))}
         </div> ) : (
            <div className="p-3 bg-[#3a3268] text-xs text-white">
              no order history found
            </div>
          )}
         
        </div>
      ) : (
        <Skeleton type="page" />
      )}
    </div>
  );
}

export default OrderHistoryPage;
